export function computeFloorAreaSquareMeters(lengthCm, widthCm, packageCount) {
    const length = Number(lengthCm);
    const width = Number(widthCm);
    const packages = Number(packageCount);
    if (!Number.isFinite(length) || length <= 0) return null;
    if (!Number.isFinite(width) || width <= 0) return null;
    if (!Number.isFinite(packages) || packages <= 0) return null;

    return (length * width * packages) / 10000;
}

export function formatFloorAreaValue(value) {
    if (!Number.isFinite(value)) return "";
    const rounded = Math.round(value * 100) / 100;
    return Number.isInteger(rounded)
        ? String(rounded)
        : rounded.toFixed(2).replace(/\.?0+$/, "");
}

export function formatFloorAreaResult(lengthCm, widthCm, packageCount) {
    const squareMeters = computeFloorAreaSquareMeters(
        lengthCm,
        widthCm,
        packageCount
    );
    if (squareMeters == null) return "";
    return `${formatFloorAreaValue(squareMeters)} m²`;
}
